@import '@pella/sash-framework/dist/index-notw.css';

* {
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none !important;
}

/**
  Global CSS variables
  Please only add variables here that are referenced in multiple components
*/
:root {
  --app-background-color: #f2f2f2;
  --alt-bg-color: black;
  --main-typography-color: black;
  --alt-typography-color: white;
  --strong-grey: #949494;
  --pella-yellow: #ffde00;
  --border-grey: #b3b3b3;
}

:focus-visible {
  border-color: black !important;
  box-shadow: none !important;
}

select {
  border-color: var(--border-grey);
  width: 260px;
}
select:focus {
  border-color: black;
  box-shadow: none;
}

input {
  border-color: var(--border-grey);
}

/**
  Global animation classes with CSS variable overrides
*/
@keyframes slideRight {
  from {
    opacity: 0;
    transform: translateX(var(--slide-distance, -50%));
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
:global(.slideRight) {
  animation: slideRight var(--transition-duration, 0.5s) ease-out;
}

@keyframes slideLeft {
  from {
    opacity: 0;
    transform: translateX(var(--slide-distance, 50%));
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
:global(.slideLeft) {
  animation: slideLeft var(--transition-duration, 0.5s) ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(var(--slide-distance, -100%));
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
:global(.slideDown) {
  animation: slideDown var(--transition-duration, 0.5s) ease-out;
}
